import $http from '@vue-util/http';

import { errorHandler } from '@/utils/ErrorHandler';
import { ONLINE_ORDER_HISTORY_ENDPOINT } from '#shared/endpoints';
import { ORDER_HISTORY } from 'config';

import { useOrderHistoryStore } from '@/stores/ppe/useOrderHistoryStore';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';

const DEFAULT_RESPONSE_TYPE = 'shipment';
const {
  onlineHistory: { onlineFallbackError },
} = ORDER_HISTORY;

export const useOnlineOrderHistoryStore = defineStore('onlineOrderHistoryStore', {
  state: () => ({
    responseType: DEFAULT_RESPONSE_TYPE,
    orderHistoryScrollTop: 0,
    shipments: [],
    orders: [],
    error: '',
    isLoading: false,
    updateOnlineOrderHistoryApiError: null,
  }),
  actions: {
    SET_ONLINE_ORDER_HISTORY({ shipments = [], orders = [], responseType = DEFAULT_RESPONSE_TYPE }) {
      this.shipments = shipments;
      this.orders = orders;
      this.responseType = responseType;
      this.error = '';
    },
    SET_ONLINE_ORDER_HISTORY_ERROR(error) {
      this.error = error;
    },
    SET_ONLINE_ORDER_HISTORY_LOADER(isLoading) {
      this.isLoading = isLoading;
    },
    SET_UPDATE_ONLINE_ORDER_HISTORY_API_ERROR(payload) {
      this.updateOnlineOrderHistoryApiError = payload;
    },

    async GET_ONLINE_ORDER_HISTORY({ dateRange }) {
      const envPropsStore = useEnvPropsStore();
      if (this.isLoading) return; // prevent API call while already waiting for previous response
      await this.SET_ONLINE_ORDER_HISTORY_ERROR('');
      await this.SET_ONLINE_ORDER_HISTORY_LOADER(true);
      this.SET_UPDATE_ONLINE_ORDER_HISTORY_API_ERROR(null);
      try {
        const response = await $http.get(ONLINE_ORDER_HISTORY_ENDPOINT, {
          headers: {
            'X-Macys-ClientId': 'SITE',
            'X-Macys-DeviceId': envPropsStore.envProps.deviceType,
          },
          params: {
            daterange: dateRange,
          },
        });
        if (!response.data?.shipments && !response.data?.orders) {
          throw new Error();
        }
        await this.SET_ONLINE_ORDER_HISTORY({ orders: response.data?.orders, responseType: response.data?.responseType });
        await useOrderHistoryStore().SET_KILLSWITCH(response?.data?.killSwitch);
        await useOrderHistoryStore().SET_SEARCH_KILLSWITCH({ searchable: response.data.killSwitch?.searchEnabled, tab: 'online-history' });
      } catch (error) {
        await this.SET_ONLINE_ORDER_HISTORY_ERROR(errorHandler(error, onlineFallbackError));
        this.SET_UPDATE_ONLINE_ORDER_HISTORY_API_ERROR(error?.response?.data?.errors?.error?.[0]);
      } finally {
        await this.SET_ONLINE_ORDER_HISTORY_LOADER(false);
      }
    },
    CLEAR_ONLINE_HISTORY() {
      this.SET_ONLINE_ORDER_HISTORY({});
    },
  },
});
